import $ from 'jquery'

$(function() {
    $('#menu-button').click(function(){
        $(this).toggleClass('active');
        $('header nav').toggleClass('show'); 
        $('body').toggleClass('no-scroll');
        $('.cover.two').fadeToggle();
    });  
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/menu.js